import { render, staticRenderFns } from "./update-resource.vue?vue&type=template&id=d09d14c4&scoped=true&"
import script from "./update-resource.vue?vue&type=script&lang=js&"
export * from "./update-resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09d14c4",
  null
  
)

export default component.exports